import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../Api/constants";

const authService = createApi({
  reducerPath: "auth",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),
  endpoints: (builder) => {
    return {
      adminLogin: builder.mutation({
        query: (loginData) => {
          return {
            url: "/api/auth/admin_login",
            method: "POST",
            body: loginData,
          };
        },
      }),
      userRegister: builder.mutation({
        query: (data) => {
          return {
            url: "api/register",
            method: "POST",
            body: data,
          };
        },
      }),
    };
  },
});
export const { useUserRegisterMutation, useAdminLoginMutation } = authService;
export default authService;
